module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tnis"
  }, [_vm._v("It is now over five hundred years since the birth of the prophet Michel de Nostredame, better known as Notradamus. Yet despite so many years having elapsed, there can surely have been no greater sign of Nostradamus’ continued strong grip on the public imagination than the aftermath to the horrifying events of September 11, 2001. The dust cloud had scarcely settled from the collapse of the New York World Trade Center towers before Britain’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Mail")]), _vm._v(" was on the news-stands with a story headlined ‘Did Nostradamus Predict it All?’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-1",
      "id": "fm5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])]), _vm._v(" The French seer was quoted as predicting:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Earthshaking fire from the world’s centre")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Will cause tremors around the New City.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-2",
      "id": "fm5-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "stnis"
  }, [_vm._v("Give or take some liberality in the translation from the original sixteenth-century French, Nostradamus had undeniably made some prediction along these lines in his pioneering little book "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Les Prophéties")]), _vm._v(" (henceforth to be known as the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Prophecies")]), _vm._v("), published in Lyons in the south of France in 1555."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-3",
      "id": "fm5-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])]), _vm._v(" Even more uncannily, particularly given the 45-degree angle at which the second suicide plane had plunged into the second tower, he had warned in another prophetic verse:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The sky will burn at 45 degrees")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Fire approaches the great New City")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Immediately a huge scattered flame leaps up.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-4",
      "id": "fm5-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "stnis"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Mail")]), _vm._v(" could hardly have been quicker off the mark in associating the New York attacks with such Nostradamus prophecies. Nonetheless, equally swift were some unknown disinformation merchants. The translations of Nostradamus’ prophetic verses that were used by the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Mail")]), _vm._v("’s columnist at least bore some passing resemblance to the French originals. This was not the case, however, with some considerably more variant and sinister ‘Nostradamus’ quotations that began circulating like wildfire amongst the United States media and, via the Internet, throughout the entire world. One version ran:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("In the City of God there will be a great thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Two Brothers torn apart by Chaos,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("While the fortress endures, the great leader will succumb.")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The third big war will begin when the big city is burning.")])]), _vm._v(" "), _c('p', {
    staticClass: "stnis"
  }, [_vm._v("Another threatened:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Two steel birds will fall from the sky on the Metropolis")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The sky will burn at 45 degrees latitude")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Fire approaches the great New City.")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Immediately a huge, scattered flame leaps up.")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Within months rivers will flow with blood")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The undead will roam earth for a little time.")])]), _vm._v(" "), _c('p', {
    staticClass: "stni"
  }, [_vm._v("To anyone conversant with Nostradamus’ true writings such quotations could readily be recognised as crude fakes. Odd lines had been taken from genuine verses, then combined with freely invented phrases such as ‘two steel birds’. One such verse was found to have been concocted several years back by Neil Marshall, then a student at Brock University, Canada, purely as a demonstration of how Nostradamus had composed deliberately vague images that the credulous then perceived as ‘fitting’ real-life events.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But just who was it in the year 2001 who had taken and manipulated these particular verses? And how was it that they had been so quick to apply them to the September 11 tragedy? That whoever created the hoaxed predictions fully intended to spread the maximum terror is all too evident from the fact that the invented lines included the mega-horror phrases ‘third big war’, ‘rivers will flow with blood’, and ‘the undead will roam the earth’. So could the hoaxer have been part of an al-Qaeda cell? Or just another brand of the sick-minded individuals who quite incomprehensibly gain satisfaction by their attempts to spread viruses over the Internet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Whoever was responsible, what is certain is that they recognised, and utilised to the full, the astonishing power of the name ‘Nostradamus’, even after more than four centuries, to evoke a deeply superstitious awe amongst millions throughout the world. Accredited with predicting everything from the Great Fire of London to the invention of electricity, there is simply not another individual, alive or dead, whose prophetic reputation carries, even remotely, any equivalent kind of mass reverence, whether this be justified or otherwise. And regardless of whether the unknown hoaxers intended it, the huge resurgence of interest in Nostradamus that they thereby sparked off in the wake of September 11 was positively breathtaking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Thus only four days after the New York attack, and with much of the world’s book-buying business otherwise in freefall, the Nostradamus writer Erika Cheetham’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nostradamus: The Complete Prophecies")]), _vm._v(" – comprising a far from accurate translation of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Les Prophéties")]), _vm._v(" plus interpretations of the verses – shot from nowhere to take the number one spot on the Amazon best-seller list."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-5",
      "id": "fm5-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("5")])]), _vm._v(" Other Nostradamus books that happened to be in print leapt to fifth, sixth, eleventh, twelfth and twenty-fifth places in the same listing. Almost overnight every lending library throughout the English-speaking world found virtually its entire stock of Nostradamus books cleared from the shelves, as was certainly the case even in my own quiet corner of Queensland, Australia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the USA the leading Nostradamian expert Victor Baines of the Nostradamus Society of America stoically accepted being woken at all hours for interviews with TV and radio chat-show hosts, not only across the States, but as far afield as the UK, Australia, New Zealand and Canada."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-6",
      "id": "fm5-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("6")])]), _vm._v(" On the Internet sites that are normally visited solely by Nostradamus aficionados began receiving so many general public hits that several temporarily shut down the majority of their pages in order to avoid being charged exorbitant operating costs by their server. It was an extraordinary set of circumstances – yet, as we will see in the course of this book, merely a twenty-first-century variant of other, earlier, equally intense waves of Nostradamus fever, often again accompanied by equally intense disinformation activities, that have recurred time and again whenever one or other European country has undergone a major crisis during the past four centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This said, it is important to note one significant peculiarity that stands out from amidst all the present-day round of Nostradamus hype. This is that the English-language authors who currently claim to be experts on Nostradamus base their reputations almost solely upon their translations of the seer’s published verses, their matching of these with historical happenings that occurred during and since Nostradamus’ time, and their general astrological know-how. As to exactly who the historical Nostradamus was, and how he could have built up such a remarkable prophetic reputation for himself, all too few English-language Nostradamians have taken more than the sketchiest of interest. Symptomatic of this, even the brief biographical entry in the edition of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(" that was current at the time of this book’s first edition contained a number of elementary factual errors."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-7",
      "id": "fm5-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This glaring deficiency is all the more odd, and even unpardonable, as an impressive amount of new historical documentation concerning Nostradamus has come to light during only the last twenty years. In 1983 the assiduous French scholar Jean Dupèbe published a transcription and partial translation from Latin into French of a cache of some fifty-one letters that had passed between Nostradamus and a number of his astrological clients during the years 1556 to 1565."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-8",
      "id": "fm5-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("8")])]), _vm._v(" Though the originals of these letters no longer exist they were gathered together by Nostradamus’ eldest son César, and translated into Latin, apparently with the intention to publish them during the early seventeenth century. Despite César’s intention never being realised, his Latin fair-copy manuscript found its way into France’s National Library, the Bibliothèque Nationale in Paris,"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-9",
      "id": "fm5-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("9")])]), _vm._v(" where it eventually came to the attention of Dupèbe who thereupon made it accessible to the world at large. Since, aside from his published writings, the letters represent by far our closest insights into Nostradamus’ mind, their interest value to the serious researcher has to be enormous, particularly given that the number of other extant items of Nostradamus correspondence can be counted on one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yet the extraordinary fact is that up to 2002, when this book’s first edition was published, virtually the only English-language author who has given this correspondence even moderate attention has been the American former stage magician James Randi, an arch-debunker and avowed sceptic of all things Nostradamian. To his considerable credit in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Mask of Nostradamus,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-10",
      "id": "fm5-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("10")])]), _vm._v(" published in 1990, Randi went to the trouble of providing translated extracts from several of Dupèbe’s summaries of the letters’ contents. However, in his over-anxiety to discredit Nostradamus’ powers as a prophet Randi made a number of factual errors on matters of history and linguistics. But at least he blazed the right trail.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By contrast, a number of ostensibly top-flight authors who had only relatively recently published authoritative books on Nostradamus had almost completely ignored the Dupèbe letter cache. The modern languages expert Peter Lemesurier is widely regarded as Britain’s leading authority on Nostradamus. Lemesurier’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nostradamus Encyclopaedia,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-11",
      "id": "fm5-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("11")])]), _vm._v(" published in 1997, represented itself as the ‘definitive reference guide to the work and world of Nostradamus’, yet the letter cache, and all the insights into Nostradamus’ life that are available from it, went essentially ignored."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#fm5-12",
      "id": "fm5-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unlike Lemesurier and the generality of most other writers on Nostradamus I have absolutely no enthusiasm for the astrology that our subject practised and held so dear. But neither have I any inclination to write merely a James Randi-style debunking of the seer. One of the undeniable historical facts about him is that he flourished throughout the first half of the sixteenth century, during the Renaissance, and is therefore a product of a particularly exciting and colourful period of Europe’s history. From France’s deepest south, where he lived for the greater part of his sixty-two years, Nostradamus annually issued sometimes dire forecasts of the events that he expected for the year to come. Whether they were believed or not they attracted much discussion amongst his contemporaries. Deservedly or otherwise, Nostradamus achieved surprising fame even in his lifetime. Kings, queens, cardinals, bishops, courtiers, lawyers, even mining magnates all sought him out. His name became a household word not only in his native France, but also in Italy, Austria, Germany, Spain and England. Even more remarkably, his reputation grew rather than waned in the wake of his death.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("These were, and continue to be, no mean achievements. Accordingly it is my belief that, to mark the 500th anniversary of his birth, Nostradamus is long overdue a really in-depth, independent-minded study of his life, his times and his continued astonishing influence. This is my aim, and this is what I will now attempt to provide.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e8c9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 75
// module chunks = 0